import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import {
  DndProps,
  ProjectDnDContext,
  ProjectDnDProvider,
  ProjectDnDStyles,
} from './project-dnd.context';
import { DnDNode, DnDNodeProps } from './DnDNode';

export interface ProjectDnDProps {
  itemsRef: React.MutableRefObject<{}>;
  tree: DnDNodeProps;
  onMoveComplete?: (payload: DndProps) => void;
  onClickAway?: () => void;
  onContextMenu?: (e: any, payload: any) => void;
  onNodeClick?: (payload: DnDNodeProps) => void;
  onNodeDoubleClick?: (payload: DnDNodeProps) => void;
  styles?: ProjectDnDStyles;
  render?: (
    props: DnDNodeProps,
    children: Array<DnDNodeProps>
  ) => React.ReactNode;
  disabled?: boolean;
}

export function ProjectDnD({
  itemsRef,
  tree,
  onMoveComplete,
  onClickAway,
  onNodeClick,
  onContextMenu,
  onNodeDoubleClick,
  styles,
  render,
  disabled,
}: ProjectDnDProps) {
  return (
    <DndProvider backend={HTML5Backend}>
      <ProjectDnDProvider
        itemsRef={itemsRef}
        tree={tree}
        styles={styles}
        render={render}
        onMoveComplete={onMoveComplete}
        onNodeClick={onNodeClick}
        onNodeDoubleClick={onNodeDoubleClick}
        onContextMenu={onContextMenu}
        onClickAway={onClickAway}
        disabled={disabled}
      >
        <ProjectDnDContext.Consumer>
          {({ tree, itemsRef }) => (
            <div style={{ paddingBottom: '200px' }}>
              {itemsRef &&
                tree &&
                tree?.children &&
                tree?.children?.length > 0 &&
                tree?.children?.map(child => (
                  <DnDNode
                    ref={(el: any) => {
                      (itemsRef.current as any)[`item-${child?.id}`] = el;
                    }}
                    key={`${child.data?.id}-${child.nodeType}`}
                    {...child}
                  />
                ))}
            </div>
          )}
        </ProjectDnDContext.Consumer>
      </ProjectDnDProvider>
    </DndProvider>
  );
}
